import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col" }

import FormKitSubmitButtonContent from "@/components/app/FormKit/FormKitSubmitButtonContent.vue";
import { computed, inject, reactive, ref } from "vue";
import { userProfilesApi } from "@/di/api";
import { formKitInjectionKey } from "@/keys";
import { FormKitSchemaNode } from "@formkit/core";
import { channelsConfig, Model } from "@/components/customer/notificationChannels/channelsConfig";

interface Lock {
  formSubmitting: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationChannelForm',
  setup(__props) {


const formKit = inject(formKitInjectionKey)

const lock = reactive<Lock>({ formSubmitting: false })

const showForm = ref<boolean>(false)

const modelAddChannel = ref<Model>({ name: '', type: '', value: '', data: {} } as Model)

const modelAddSchema = computed((): FormKitSchemaNode[] => {
  const defaults: FormKitSchemaNode[] = [
    {
      $formkit: 'select',
      name: 'type',
      placeholder: 'Choose notification channel',
      options: channelsConfig.allowedChannels
          .filter((ch) => ch.creatable)
          .map((ch) => ({ value: ch.name, label: ch.title })),
      validation: [['required']],
      validationVisibility: 'submit'
    },
    {
      $formkit: 'text',
      name: 'name',
      placeholder: 'Name',
      validation: [['required']],
      validationVisibility: 'submit'
    },
    {
      $formkit: 'text',
      name: 'value',
      placeholder: channelsConfig.getLabelForChannel(modelAddChannel.value.type, 'Value'),
      validation: [['required']],
      validationVisibility: 'submit'
    }
  ]

  return [
    ...defaults,
    ...channelsConfig.getAdditionalSchema(modelAddChannel.value.type)
  ].map((item) => {
    // @ts-ignore
    item.outerClass = 'mb-3'

    return item
  })
})

function showAddChannelForm (): void {
  showForm.value = true
}

async function addChannel (): Promise<void> {
  lock.formSubmitting = true

  try {
    await userProfilesApi.addNotificationChannel(channelsConfig.makeCreationData(modelAddChannel.value))
  } finally {
    formKit?.reset('add-channel')
    lock.formSubmitting = false
    showForm.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKitSchema = _resolveComponent("FormKitSchema")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", { class: "col" }, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-sm",
          style: {"margin-bottom":"16px"},
          onClick: showAddChannelForm
        }, " Add new channel ")
      ])
    ]),
    (showForm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FormKit, {
              modelValue: modelAddChannel.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelAddChannel).value = $event)),
              type: "form",
              name: "add-channel",
              actions: false,
              onSubmit: addChannel
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FormKitSchema, { schema: _unref(modelAddSchema) }, null, 8, ["schema"]),
                _createVNode(_component_FormKit, {
                  type: "submit",
                  disabled: lock.formSubmitting,
                  "input-class": "btn btn-primary btn-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(FormKitSubmitButtonContent, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Add")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})